import omit from 'lodash/omit';

export const excludeOptionsFromArray = (values = [], excludeValues = []) =>
  values.filter(option => !excludeValues.includes(option.value));

export const excludeOptionsFromObject = (values = {}, excludeValues = []) =>
  omit(values, excludeValues);
